import { render } from "./CollectionForm.vue?vue&type=template&id=9889b43e&ts=true"
import script from "./CollectionForm.vue?vue&type=script&lang=ts"
export * from "./CollectionForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__